<template>
  <v-data-table :group-by="groupBy" :headers="headers" :item-class="getItemClass" :items="tehtavat"
                class="mt-2"
                disable-pagination
                hide-default-footer
                @click:row="(item) => openEdit(item)"
  >
    <template v-slot:group.header="{items}">
      <td class="text-subtitle-1 primary" colspan="100%">{{
          items[0] && items[0].vastuualue && items[0].vastuualue.nimi
        }}
      </td>
    </template>
    <template v-slot:item.vastuuuser="{item}">
      {{ item.vastuuuser && item.vastuuuser.firstname }}
      {{ item.vastuuuser && item.vastuuuser.lastname }}
    </template>
    <template v-slot:item.maarapvm="{item}">
      {{ item.maarapvm && $formatDateNoTime(item.maarapvm) }}
    </template>
    <template v-slot:item.viimeinenKommentti="{item}">
      {{ item.viimeinenKommentti && $formatDateTime(item.viimeinenKommentti) }}
    </template>
    <template v-slot:item.valmiusProsentti="{item}">
      <div v-if="item.valmiusProsentti" class="text-left">
        <v-avatar
            :color="$getValmiusprosenttiColor(item.valmiusProsentti)"
            size="32"></v-avatar>
        <span> {{ $formatPisteet(item.valmiusProsentti) }} %</span>
      </div>
    </template>
    <template v-slot:item._="{item}">
      <v-btn icon @click="openEdit(item)">
        <v-icon
            v-if="$hasEditPermission(item.vastuualueId) || item.vastuuuserId === $user.id || (item.tehtavaHenkiloLinkit && item.tehtavaHenkiloLinkit.some(l => l.henkiloId === $user.id))"
            small>mdi mdi-pencil
        </v-icon>
        <v-icon v-else small>mdi mdi-arrow-right</v-icon>
      </v-btn>
    </template>
  </v-data-table>
</template>

<script>
import store from "@/store";

export default {
  name: "TehtavaTable",
  props: {
    tehtavat: {
      required: true,
      type: Array,
    },
    groupBy: {
      required: false,
      default: null,
    }
  },
  data() {
    return {
      headers: [
        {
          text: this.$t('tehtava.otsikko'),
          value: 'otsikko',
        },
        {
          text: this.$t('tehtava.vastuuuser'),
          value: 'vastuuuser',
          sort: (a, b) => {
            return [a.firstname, a.lastname].join('_').localeCompare([b.firstname, b.lastname].join('_'))
          }
        },
        {
          text: this.$tc('tehtava.maarapvm', 1),
          value: 'maarapvm'
        },
        {
          text: this.$tc('tehtava.valmius_prosentti', 1),
          value: 'valmiusProsentti',
          align: 'start'
        },
        {
          text: this.$tc('tehtava.painotus', 1),
          value: 'painotus',
          align: 'end'
        },
        {
          text: this.$t('tehtava.viimeinen_kommentti'),
          value: 'viimeinenKommentti',
          align: ''
        },
        {
          text: '',
          value: '_'
        }
      ]
    }
  },
  methods: {
    getItemClass(item) {
      /*if (item.valmiusProsentti === 100) {
        return 'tehtava-bg-100'
      }
      if (item.valmiusProsentti > 0) {
        return 'tehtava-bg-50'
      }*/
      if (item.tila === 'Valmis') {
        return 'tehtava-bg-100 tehtava-row'
      }
      if (item.tila === 'Kaynnissa') {
        return 'tehtava-bg-50 tehtava-row'
      }
      return 'tehtava-bg-0 tehtava-row'
    },
    openEdit(tehtava) {
      store.commit('tehtavat/SET_FILTERED_TEHTAVAT', this.tehtavat);
      if (tehtava == null) {
        this.$router.push({name: 'tehtava_uusi'})
        return;
      }
      this.$router.push({name: 'tehtava_muokkaus', params: {tehtavaId: tehtava.id}})
    }
  }
}
</script>
<style lang="scss">
tr.tehtava-bg-100 {
  td:first-child {
    background-color: var(--v-success-lighten4);
    color: #000;
  }
}

tr.tehtava-row {
  cursor: pointer;
}

tr.tehtava-bg-50 {
  td:first-child {
    background-color: var(--v-warning-lighten5);
    color: #000;
  }
}

</style>

<style scoped>

</style>